import pb from './pb';

// Must include https://
export const CDN_BASE = 'https://media.myfavv.live';

// Folder inside the R2 bucket
export const CDN_FOLDER = 'posts';

// Set to false to instantly go back to PocketBase URLs
export const USE_CDN = true;

// PocketBase multi-file fields return arrays; always get one filename
export function firstFile(value) {
  return Array.isArray(value) ? value[0] : value;
}

// Original PocketBase URL (used as the fallback)
export function getPbUrl(record, value) {
  const file = firstFile(value);
  if (!file || !record) return null;
  if (/^https?:\/\//i.test(file)) return file;
  return pb.files.getURL(record, file);
}

// CDN URL: https://media.myfavv.live/posts/<filename>
export function getMediaUrl(record, value) {
  const file = firstFile(value);
  if (!file) return null;
  if (/^https?:\/\//i.test(file)) return file;
  if (!USE_CDN) return getPbUrl(record, file);

  // tolerate values saved as "posts/abc.png" or "/posts/abc.png"
  const clean = String(file).replace(/^\/+/, '').replace(new RegExp(`^${CDN_FOLDER}/`), '');
  return `${CDN_BASE}/${CDN_FOLDER}/${clean}`;
}